export default __webpack_public_path__ + "static/media/Close.bd3b35d7.svg";